import { AttendanceDetails, Loader } from '../Widgets';
import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { AppSettings, Employee } from 'service/Models';
import ServerGateway from 'service/ServerGateway';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronRight, faClock } from '@fortawesome/free-solid-svg-icons';
import toast, { Toaster } from 'react-hot-toast';
import c3 from 'c3';
import 'c3/c3.css';

export const Attendance = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [groups, setGroups] = useState<[]>([]);
    const [groupId, setGroupId] = useState<number>(0);
    const [date, setDate] = useState<any>(moment().format("YYYY-MM-DD"));
    const [attendance, setAttendance] = useState<any[]>([]);
    const [summary, setSummary] = useState<any>();
    const [expandedItem, setExpandedItem] = useState<string>('');
    const [displayMode, setDisplayMode] = useState<string>('summary');
    const [attendanceStatus, setAttendanceStatus] = useState<string[]>(['Present']);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const chartRef = useRef(null);

    useEffect(() => {
        if (groups.length === 0) {
            ServerGateway.getEmployeeGroups()
                .then((data) => {
                    setGroups(data);
                });
        }
    }, []);

    useEffect(() => {
        if (date) {
            loadAttendance();
        }
    }, [date, groupId]);

    const loadAttendance = () => {
        setIsLoading(true);
        ServerGateway
            .getAttendance(date, groupId)
            .then((data) => {
                setAttendance(data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    useEffect(() => {
        if (date && attendance) {
            let summary = {
                numOfEmployees: attendance.length,
                numOfPresent: attendance.filter(x => (x.status == "Present" || x.status == "HalfDay")).length,
                numOfAbsent: attendance.filter(x => (x.status == "Absent" || x.status == "NA" || x.status == 'LossOfPay')).length,
                numOfLeave: attendance.filter(x => x.status == "Leave").length,
                numOfLateLogins: attendance.filter(x => x.lateLoginTime > 0).length,
                numOfEarlyLogouts: attendance.filter(x => x.earlyLogoutTime > 0).length,
                numOfAutoLogouts: attendance.filter(x => x.isAutoLogout).length
            }
            setSummary(summary);
        }
    }, [attendance]);

    useEffect(() => {
        if (summary && displayMode === "summary") {
            drawAttendanceChart();
        }
    }, [summary, displayMode]);

    const drawAttendanceChart = () => {
        console.log("Drawing c3 Graph");
        c3.generate({
            bindto: '#attendance-chart',
            legend: { show: false },
            data: {
                columns: [
                    ['Present', summary.numOfPresent],
                    ['Absent', summary.numOfAbsent],
                    ['Leave', summary.numOfLeave],
                ],
                colors: {
                    Present: '#69c050',
                    Absent: '#f44336',
                    Leave: '#ffca28',
                },
                type: 'pie'
            }
        });
    }

    const showAttendanceDetails = (status) => {
        if (status === "Present") {
            setAttendanceStatus(["Present", "HalfDay"]);
        }
        else if (status === "Absent") {
            setAttendanceStatus(["Absent", "NA", "LossOfPay"]);
        }
        else {
            setAttendanceStatus([status]);
        }
        setDisplayMode("detailed");
    }

    const handleDateChange = (e) => {
        setDate(e.target.value);
    }

    const getClassNameBasedOnStatus = (status) => {
        if (status === "Present") {
            return "badge bg-success"
        }
        else if (status === "Absent" || status === "LOP") {
            return "badge bg-danger"
        }
        else if (status === "Leave") {
            return "badge bg-warning"
        }
        else if (status === "WeeklyOff") {
            return "badge bg-primary"
        }
        return "badge bg-secondary";
    }

    return (
        <div className="page-attendance">
            <div className='container'>
                <div className='row'>
                    <h2>Attendance</h2>
                </div>
                <div className='row'>
                    <input type="date" className="form-control" value={date} onChange={handleDateChange} style={{ textAlign: "center" }}></input>
                </div>
                <div className='row'>
                    <select className="form-control" value={groupId} onChange={(e) => setGroupId(parseInt(e.target.value))}>
                        <option value="0">All</option>
                        {groups.map((group: any) => {
                            return <option key={group.id} value={group.id}>{group.name}</option>
                        })}
                    </select>
                </div>
                {displayMode === "summary" &&
                    <div className="summary-container container">
                        <div className='row' style={{ marginTop: "10px" }}>
                            <div className='col-md-12'>
                                <div ref={chartRef} id="attendance-chart"></div>
                            </div>
                        </div>
                        <div className='row' style={{ marginTop: "10px" }}>
                            <table className="table table-bordered table-hover" style={{ textAlign: "center" }}>
                                <tr>
                                    <td className="row-header">
                                        Total
                                    </td>
                                    <td className="row-value">
                                        <b>{summary?.numOfEmployees}</b>
                                    </td>
                                    <td className='row-action'></td>
                                </tr>
                                <tr onClick={() => showAttendanceDetails("Present")}>
                                    <td  className="row-header">
                                        Present
                                    </td>
                                    <td className="row-value">
                                        <b>{summary?.numOfPresent}</b>
                                    </td>
                                    <td className='row-action'>
                                        <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
                                    </td>
                                </tr>
                                <tr onClick={() => showAttendanceDetails("Absent")}>
                                    <td  className="row-header">
                                        Absent
                                    </td>
                                    <td className="row-value">
                                        <b>{summary?.numOfAbsent}</b>
                                    </td>
                                    <td className='row-action'>
                                        <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
                                    </td>
                                </tr>
                                <tr onClick={() => showAttendanceDetails("Leave")}>
                                    <td  className="row-header">
                                        Leave
                                    </td>
                                    <td className="row-value">
                                        <b>{summary?.numOfLeave}</b>
                                    </td>
                                    <td className='row-action'>
                                        <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
                                    </td>
                                </tr>
                                <tr onClick={() => setDisplayMode("late-logins")}>
                                    <td  className="row-header">
                                        Late Login
                                    </td>
                                    <td className="row-value">
                                        <b>{summary?.numOfLateLogins}</b>
                                    </td>
                                    <td className='row-action'>
                                        <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
                                    </td>
                                </tr>
                                <tr onClick={() => setDisplayMode("early-logouts")}>
                                    <td  className="row-header">
                                        Early Logout
                                    </td>
                                    <td className="row-value">
                                        <b>{summary?.numOfEarlyLogouts}</b>
                                    </td>
                                    <td className='row-action'>
                                        <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
                                    </td>
                                </tr>
                                <tr onClick={() => setDisplayMode("auto-logout")}>
                                    <td className="row-header">
                                        Auto Logout
                                    </td>
                                    <td className="row-value">
                                        <b>{summary?.numOfAutoLogouts}</b>
                                    </td>
                                    <td className='row-action'>
                                        <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                }
                {displayMode === "detailed" &&
                    <div className="detailed-container container">
                        <div className="row mt-2">
                            <div className="btn btn-sm btn-danger" onClick={() => setDisplayMode("summary")}>
                                Back
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className="list-group list-group-flush">
                                {attendance.map((item) => (
                                    <>
                                        {attendanceStatus.includes(item.status) &&
                                            <div className="list-group-item" key={item.id}>
                                                <AttendanceDetails attendance={item} show="Employee" />
                                            </div>
                                        }
                                    </>
                                ))}
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="btn btn-sm btn-danger" onClick={() => setDisplayMode("summary")}>
                                Back
                            </div>
                        </div>
                    </div>
                }
                {displayMode === "late-logins" &&
                    <div className="detailed-container container">
                        <div className="row mt-2">
                            <div className="btn btn-sm btn-danger" onClick={() => setDisplayMode("summary")}>
                                Back
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className="list-group list-group-flush">
                                {attendance.map((item) => (
                                    <>
                                        {item.lateLoginTime > 0 &&
                                            <div className="list-group-item" key={item.id}>
                                                <AttendanceDetails attendance={item} show="Employee" />
                                            </div>
                                        }
                                    </>
                                ))}
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="btn btn-sm btn-danger" onClick={() => setDisplayMode("summary")}>
                                Back
                            </div>
                        </div>
                    </div>
                }
                {displayMode === "early-logouts" &&
                    <div className="detailed-container container">
                        <div className="row mt-2">
                            <div className="btn btn-sm btn-danger" onClick={() => setDisplayMode("summary")}>
                                Back
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className="list-group list-group-flush">
                                {attendance.map((item) => (
                                    <>
                                        {item.earlyLogoutTime > 0 &&
                                            <div className="list-group-item" key={item.id}>
                                                <AttendanceDetails attendance={item} show="Employee" />
                                            </div>
                                        }
                                    </>
                                ))}
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="btn btn-sm btn-danger" onClick={() => setDisplayMode("summary")}>
                                Back
                            </div>
                        </div>
                    </div>
                }
                {displayMode === "auto-logout" &&
                    <div className="detailed-container container">
                        <div className="row mt-2">
                            <div className="btn btn-sm btn-danger" onClick={() => setDisplayMode("summary")}>
                                Back
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className="list-group list-group-flush">
                                {attendance.map((item) => (
                                    <>
                                        {item.isAutoLogout &&
                                            <div className="list-group-item" key={item.id}>
                                                <AttendanceDetails attendance={item} show="Employee" />
                                            </div>
                                        }
                                    </>
                                ))}
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="btn btn-sm btn-danger" onClick={() => setDisplayMode("summary")}>
                                Back
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div >
    );
}